<div class="f-basic-card" data-automation-id="f-basic-card">
  <div class="f-basic-card-header body-70" data-automation-id="f-basic-card-header">
    <ng-container *ngTemplateOutlet="headerTitle"></ng-container>
  </div>

  <div class="f-basic-card-content body-70" data-automation-id="f-basic-card-content">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </div>
</div>
